import _ from 'lodash'

class Tab {
  selector: any
  els: any
  targetEls: any

  constructor(selector: any) {
    this.selector = selector

    this.main()
  }

  public main() {
    this.els = document.querySelectorAll(this.selector)

    if (!this.els.length) return

    this.targetEls = []

    _.forEach(this.els, el => {
      this.targetEls.push(
        document.getElementById(el.getAttribute('aria-controls'))
      )
    })

    _.forEach(this.els, el => {
      el.addEventListener('click', this.onClick.bind(this))
    })

    _.forEach(this.els, el => {
      if (el.getAttribute('aria-selected') === 'true') {
        el.click()
      }
    })
  }

  public onClick(e: any) {
    const triggerEl = e.currentTarget
    const targetEl: any = document.getElementById(
      triggerEl.getAttribute('aria-controls')
    )

    this.reset()

    triggerEl.setAttribute('aria-selected', 'true')
    targetEl.classList.add('is-active')
  }

  public reset() {
    _.forEach(this.els, el => {
      el.setAttribute('aria-selected', 'false')
    })

    _.forEach(this.targetEls, el => {
      el.classList.remove('is-active')
    })
  }
}

export default Tab
